import type {
  GroupOption as IGroupOption,
  Option,
} from "src/components/SelectV2/SelectV2.types.ts";
import type { VirtualItem } from "@tanstack/react-virtual";
import type { UseInteractionsReturn } from "@floating-ui/react";
import React, { type MutableRefObject } from "react";
import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { Option as OptionComponent } from "./Option";

export const GroupOption = ({
  item,
  activeIndex,
  virtualItem,
  interactions,
  onSelect,
  listRef,
  flatOptions,
  value,
  isMultiple,
}: {
  item: IGroupOption<any>;
  activeIndex: number | null;
  virtualItem: VirtualItem;
  interactions: UseInteractionsReturn;
  onSelect: (item: Option<any>) => void;
  listRef: MutableRefObject<Array<HTMLElement | null>>;
  flatOptions: Option<any>[];
  value: any;
  isMultiple: boolean;
}) => {
  return (
    <div
      key={String(item.value)}
      css={styles.virtualOption({
        virtualItem,
      })}
    >
      <div css={styles.groupLabel}>{item.label}</div>
      {item.options!.map((childOption) => {
        return (
          <OptionComponent
            value={value}
            isMultiple={isMultiple}
            listRef={listRef}
            item={childOption}
            onSelect={onSelect}
            interactions={interactions}
            flatOptions={flatOptions}
            activeIndex={activeIndex}
          />
        );
      })}
    </div>
  );
};
